export const sortArray = (inputArray, sortingArray) => {
  const sortedArray = [...inputArray]
  sortedArray.sort((a, b) => {
    return sortingArray.indexOf(a.id) - sortingArray.indexOf(b.id)
  })
  return sortedArray
}
